/**
 * The initial value of Symbol.match is the well-known symbol @@match
 * https://tc39.es/ecma262/#sec-symbol.match
 */
export const symbolMatch = () => Symbol("Symbol.match");
